import { SaveBar } from '../ActionBar/SaveBar';
import { Paper } from '../Paper/Paper';

import { PaperFormProps } from './PaperForm.decl';

import { Form } from '@aircall/tractor';
import { Banner, BannerHeading, BannerIcon, ThemeProvider } from '@aircall/tractor-v2';
import { AnimatePresence } from 'framer-motion';
import { Form as RRForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';

export function PaperForm<FormValues, InitialFormValues = FormValues>({
  children,
  title,
  subtitle,
  shouldBlockNavigation,
  formProps,
  ...paperProps
}: PaperFormProps<FormValues, InitialFormValues>) {
  const { t } = useTranslation();
  return (
    <RRForm<FormValues, InitialFormValues> {...formProps}>
      {(formRenderProps) => (
        <Form onSubmit={formRenderProps.handleSubmit}>
          <Paper
            {...paperProps}
            title={title}
            subtitle={subtitle}
            footer={
              <>
                <AnimatePresence>
                  {formRenderProps.submitError && (
                    <ThemeProvider>
                      <Banner variant='critical'>
                        <BannerIcon />
                        <BannerHeading>{t(formRenderProps.submitError)}</BannerHeading>
                      </Banner>
                    </ThemeProvider>
                  )}
                </AnimatePresence>
                <SaveBar
                  formProps={formRenderProps}
                  shouldUseContext={false}
                  shouldBlockNavigation={shouldBlockNavigation}
                />
              </>
            }
          >
            {children(formRenderProps)}
          </Paper>
        </Form>
      )}
    </RRForm>
  );
}
